module.exports = __webpack_public_path__ + "img/CF.da0ec0b8.svg";